module.exports = __webpack_public_path__ + "img/sub_main_연구발표.69dccc66.png";